import { PaymentInformationProps, ReusablePaymentInformation } from './ReusablePaymentInformation';
import S from './SingularPaymentInformation.module.scss';
export const SuccessSingularPaymentInformation = (props: PaymentInformationProps) => {
  const {
    customerName
  } = props;
  return <div className={S.wrapper} data-sentry-component="SuccessSingularPaymentInformation" data-sentry-source-file="SuccessSingularPaymentInformation.tsx">
      <div className={S.business_title}>{customerName}</div>
      <div className={S.information_content}>
        <ReusablePaymentInformation {...props} data-sentry-element="ReusablePaymentInformation" data-sentry-source-file="SuccessSingularPaymentInformation.tsx" />
      </div>
    </div>;
};